<template>
	<div class="step3">
		<div class="header">
			<img class="logo" src="../../static/img/logo.png" />
			<h5 class="header_tit"><span>|</span> 会员管理系统</h5>
			<p class="welcom">欢迎您 <span class="name">{{name}}</span><span>|</span></p>
			<a class="out"  @click="out">退出</a>
		</div>
		<div class="middle">
			<p class="introducer">入会流程</p>
			<div class="con">
				<div class="shade" v-show="ma" @click="shade_closed">
					<div>
						<p style="color: red;text-align: center;">注：转账请备注个人会员姓名</p>
						<img src="../../static/img/ma.png" />
					</div>
					
				</div>
				
				<div class="con_top">
					<p class="flow_pic">
						<img class="yet" src="../../static/img/cirle.png" /> <span class="flow1 flow">注册账号</span> <span class="line line1"></span>
						<img class="yet" src="../../static/img/cirle.png" /> <span class="flow1 flow">填写入会申请表</span> <span class="line line1"></span>
						<span class="cirl">3</span> <span class="flow2 flow">缴费并等待审核</span> 
					</p>
				</div>
				<div class="tit">
						<img class="wait fl clearfix" src="../../static/img/wait.png" />
						<div class="fl clearfix" style="height: 102px;padding-top: 22px;margin-left: 20px;">
							<p style="font-size: 16px;color: #404040;font-weight: bold;line-height: 40px;">您的资料正在审核中</p>
							<span style="line-height: 40px;">所有资料审批通过即可成为正式会员，获得会员编号，享受完整会员服务。</span>
						</div>
				</div>
				<div class="con_center">
					<div class="center_con">
						<img class="hetong" src="../../static/img/hetong.png"  />
						<div class="center_center">
							<p class="center_tit">入会申请表审核</p>
							<p class="shenhe" v-show="shenhe">审核中...</p>
							<p class="btns" v-show="bohui">
								<span class="bohui">驳回</span>
								<span class="watch" @click='check' style="cursor:pointer;" >查看驳回理由</span>
								<router-link class="back"  to="/person1">返回修改</router-link>
							</p>
							<p class="pass" v-show="pass">审核通过</p>
						</div>
					</div>
				</div>	
				<div class="con_bot">
					<div class="bot_top">
						<img class="copy_img" src="../../static/img/copy5.png"  />
						<div class="bot_top_right">
							<p>缴纳会费 <span style="font-size: 14px;color: red;">(个人会员如需要开具发票，请致电联系会员服务部工作人员)</span></p>
							<span>普通单位会员¥5000/年 &nbsp;&nbsp;&nbsp;理事及以上单位会员¥10000/年 &nbsp;&nbsp;&nbsp;个人会员¥480/年</span>
						</div>
					</div>

					<div class="codeMsg">
						<input v-model="code" :class="type== 1? 'b1':'b2'" @input="changeType" placeholder="请填写本次缴费的转账卡号或支付宝账号，以便工作人员确认转账信息" />
						<span @click="submitCode">提交</span>
					</div>	
					
					<div class="bot_bot">
						<p>转账信息</p>
						<div class="msg">
							<span></span>
							<p>
								会费请汇至： 中国质量协会<br>	
							 	银行帐号：0200002809014498969 <br>	
							 	开 户 行：工商银行北京西四支行 <br>	
							 	请注明项目：会费 及个人会员姓名<br>	
							</p>
						</div>
						
						<p style="text-align: left;font-size: 14px;">个人会员请选择支付宝付款</p>
						<div style="width: 100%;height: 50px;">
							<div class="pay_box">
								<input type="radio"  style="vertical-align: middle;" checked/>
								<img style="display: inline-block;width: 28px;height: 29px;vertical-align: middle;" src="../../static/img/pay.png" />
								<span>支付宝付款</span>
								<span style="float:right;height: 100%;line-height: 50px;color: #FF3838;margin-right: 20px;" >¥480/年</span>
							</div>
							<button  class="pay_btn" @click="pay">立即支付</button>
						</div>											
					</div>
					
					
					
					<div class="payment">
						<span style="font-size: 16px;font-weight: bold;color: #404040;">缴费状态：</span>
						<span style="color: #FF9600;">{{status}}</span>
					</div>					
				</div>
			</div>			
		</div>
		<bottom></bottom>
	</div>
</template>

<script>
	import { Message, MessageBox } from 'element-ui'
	import Qs from 'qs'
	import bottom from './Bottom'
  	export default {
  		components: {
			bottom
		},
	    data() {	    	
		    return {
		    	type:1,
		    	code:'',
		    	file: '',
				filename: '',
		    	ma:false,
		    	status:'',
		    	shenhe:false,
		    	bohui:false,
		    	pass:false,
		    	name:'',
		    };
	    },
	    
		created() {
	  	},
	  	mounted() {
	  		if(sessionStorage.getItem('name')){
			    this.name =  sessionStorage.getItem('name');
			};
		   if(sessionStorage.getItem('Token')){
			    var token =  sessionStorage.getItem('Token');
			};
			var data1={
				'access-token':token
			};
		   this.$axios({
				method: 'post',
				url: 'personal/applicationform',
				data: Qs.stringify(data1)
			}).then(response => {
				if(response.data.state==2){
					switch(Number(response.data.data.apply_status)){
						case 0:					
						this.shenhe=true;
						break;
						case 1:
						this.pass=true;
						break;
						default:
						this.bohui=true;
					}
				}else{
					this.$toast(response.data.msg);
				}
				
			
			});	
			this.$axios({
				method: 'post',
				url: 'payment/paymentpage_2',
				data: Qs.stringify(data1)
			}).then(response => {
				this.status = response.data.msg;					
			});	  
			
		  },
	    methods: {
	    	changeType(){
	    		if(this.code){
	    			this.type =2;
	    		}else{
	    			this.type =1;
	    		}	    		
	    	},
	    	submitCode(){
	    		if(!this.code){
	    			this.$message('请填写本次缴费的转账卡号或支付宝账号!');
	    			return false;
	    		}
	    		if(sessionStorage.getItem('Token')) {
					var token = sessionStorage.getItem('Token');
				}
	    		var data1={
	    			'access-token':token,
					account:this.code
				};
	    		this.$axios({
						method: 'post',
						url: 'personal/updateaccount',
						data: Qs.stringify(data1)
					}).then(response => {
						this.$message(response.data.msg);				
					});	 
	    	},
	    	uploadFile(event) {
				const isLt2M = event.target.files[0].size / 1024 / 1024 < 10 // 上传头像图片大小不能超过 2MB
				if(!isLt2M) {
					this.$toast('图片选择失败，每张图片大小不能超过 10MB,请重新选择!');
				} else {
					this.file = event.target.files[0]; //获取input的图片file值
					this.filename = event.target.files[0].name;
					this.$toast('文件选择成功！');
				}
			},
			upload() {
				if(this.filename == "") {
					this.$toast('请选择要上传的文件！')
					return false
				};
				if(sessionStorage.getItem('Token')) {
					var token = sessionStorage.getItem('Token');
				}
				let fileFormData = new FormData();
				fileFormData.append('file', this.file, this.filename); //filename是键，file是值，就是要传的文件，test.zip是要传的文件名
				fileFormData.append('access-token',token);
				
				let requestConfig = {
					headers: {
						'Content-Type': 'multipart/form-data'
					},
				};
				this.$axios.post('payment/checkpaymentprogress', fileFormData, requestConfig).then(response => {
					this.$toast(response.data.msg);
				});
			},
			query(){
				if(sessionStorage.getItem('Token')){
				    var token =  sessionStorage.getItem('Token');
				};
				var data1={
					'access-token':token
				};
				this.$axios({
					method: 'post',
					url: 'payment/checkpaymentprogress',
					data: Qs.stringify(data1)
				}).then(response => {
					this.$toast(response.data.msg)				
				});	  
			},
	    	out(){
	    		if(sessionStorage.getItem('Token')){
			        var token =  sessionStorage.getItem('Token');
			    };
			    var data1={
					'access-token':token
				};
			    this.$axios({
					method: 'post',
					url: 'user/logout',
					data: Qs.stringify(data1)
				}).then(response => {
					if(response.data.state==1){
//						sessionStorage.removeItem('Token');
//						localStorage.removeItem('sessionid');
						localStorage.clear();
						sessionStorage.clear();
						this.$router.push('/login');
					}else{
						this.$toast(response.data.msg);
					}
				})
	    	},
			check(){
				if(sessionStorage.getItem('Token')){
				    var token =  sessionStorage.getItem('Token');
				};
				
				var data1={
					'access-token':token
				};
				this.$axios({
					method: 'post',
					url: 'personal/applicationform',
					data: Qs.stringify(data1)
				}).then(response => {
					if(response.data.state==2){
						this.$alert(response.data.data.reason, '驳回理由', {
				          	callback: action => {
			            
			        		}
				      	});	
					}else{
						this.$toast(response.data.msg);
					}									
				});	  
			},
			pay(){
				var time = new Date();
				var month = time.getMonth() + 1;
				var date = time.getDate();
				if(month==11 && date>=30){
					this.$alert('尊敬的个人会员，自11月30日起至12月31日，中国质量会财务结算期间，支付宝渠道暂时关闭，请通过协会银行账户汇款缴纳会费，感谢您的理解与配合！', '温馨提示：', {
			          confirmButtonText: '确定',
			       });
					return false;
				}else if(month==12 && date<=31){
					this.$alert('尊敬的个人会员，自11月30日起至12月31日，中国质量会财务结算期间，支付宝渠道暂时关闭，请通过协会银行账户汇款缴纳会费，感谢您的理解与配合！', '温馨提示：', {
			          confirmButtonText: '确定',
			       	});
					return false;
				};
				this.ma=true;
			},
			shade_closed(){
				this.ma=false;
			},
			
	    }
	}

</script>
<style scoped >
.clearfix::after {
	content: ".";
	clear: both;
	visibility: hidden;
	height: 0;
	display: block;
	line-height: 0;
}
	
.clearfix {
	zoom: 1;
}
.fl{
	float: left;
}
.step3 {
	width: 100%;
	height: auto;
	background: #fff;
	font-family: PingFangSC-Medium;
	font-size: 14px;
}

.header {
	height: 80px;
	position: relative;
}

.logo {
	width: 211px;
	height: 43px;
	position: absolute;
	top: 16px;
	left: 254px;
}

.header_tit {
	position: absolute;
	top: 26px;
	left: 480px;
	height: 28px;
	font-size: 20px;
	font-weight: bold;
	color: rgba(0, 94, 179, 1);
	line-height: 28px;
}

.header_tit span {
	height: 17px;
	color: #E8E8E8;
}

.welcom {
	position: absolute;
	top: 30px;
	right: 271px;
	width: 340px;
	text-align: right;
	color: #808080;
}

.name {
	color: #4A90E2;
	margin-right: 14px;
}

.out {
	cursor: pointer;
	position: absolute;
	top: 30px;
	right: 226px;
	font-size: 14px;
	font-weight: bold;
	color: #808080;
	line-height: 20px;
}

.middle {
	border-top: 1px solid rgba(0, 0, 0, 0);
	box-sizing: border-box;
	width: 100%;
	height: auto;
	background: rgba(246, 248, 249, 1);
	padding-bottom: 45px;
}

.introducer {
	font-size: 24px;
	color: #404040;
	text-align: left;
	text-indent: 254px;
	line-height: 75px;
}

.con {
	text-align: left;
	margin: 0 auto;
	width: 960px;
	height: auto;
	background: rgba(255, 255, 255, 1);
	box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.04);
	padding-bottom: 100px;
}
.shade{
	position: fixed;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background: rgba(0,0,0,.7);
	z-index: 99;
}
.shade div{
	width: 300px;
	height:300px;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%,-50%);
}
.shade img{
	width: 300px;
	height:300px;
}
.shade p{
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	font-size: 16px;
}
.con_top {
	padding-top: 25px;
	height: 45px;
	border-bottom: 1px solid #E0E0E0;
}

.flow_pic {
	height: 20px;
	text-align: center;
	vertical-align: middle;
	color: #595959;
}

.yet {
	margin-right: 14px;
	width: 20px;
	height: 20px;
	display: inline-block;
	vertical-align: middle;
}

.flow1 {
	color: #0076FF;
}

.flow2 {
	color: #FF9600;
}

.line {
	margin: 0 19px;
	width: 47px;
	height: 2px;
	display: inline-block;
	background: #BFBFBF;
	vertical-align: middle;
}

.line1 {
	background: #0076FF;
}

.cirl {
	display: inline-block;
	width: 20px;
	height: 20px;
	border: 1px solid #BFBFBF;
	border-radius: 100%;
	line-height: 20px;
	text-align: center;
	color: #BFBFBF;
	margin-right: 14px;
}
.tit{
	width: 100%;
	overflow: hidden;
	padding: 116px 0 131px 118px;
	box-sizing: border-box;
	border-bottom: 2px solid #E0E0E0;
}
.wait{
	width: 175px;
	height: 124px;
}
.con_center {
	width: 720px;
	height: 250px;
	margin-bottom: 35px;
	border-bottom: 1px solid #979797;
	margin: 55px 0 35px 111px;
}

.center_con {
	height: 160px;
	width: 100%;
}
.hetong {
	width: 80px;
	height: 80px;
	float: left;
}
.center_center {
	/*width: 243px;*/
	height: 150px;
	float: left;
	margin-left: 34px;
}

.center_tit {
	color: #404040;
	font-size: 16px;
	font-weight: bold;
	margin-bottom: 16px;
}

.shenhe {
	height: 21px;
	line-height: 21px;
	padding-left: 30px;
	background: url(../../static/img/see.png) no-repeat left 4px;
	background-size:23px 15px ;
	font-family: PingFangSC-Regular;
	color: #F5A623;
	margin-bottom: 16px;
}
.btns {
	margin-bottom: 16px;
	font-family: PingFangSC-Regular;
}

.bohui {
	height: 20px;
	line-height: 20px;
	padding-left: 35px;
	background: url(../../static/img/bohui.png) no-repeat left top;
	background-size:22px 20px;
	color: #FF2C46;
}

.watch {
	color: #0076FF;
	margin: 0 35px 0 20px;
}
.back {
	color: #0076FF;
}
.pass {
	height: 20px;
	line-height: 20px;
	padding-left: 35px;
	background: url(../../static/img/pass.png) no-repeat left top;
	background-size:22px 20px;
	color: #16A085;
}

.center_right {
	width: 240px;
	height: 100px;
	float: right;
	color: #4A90E2;
	font-family: PingFangSC-Regular;
}

.center_right a {
	display: inline-block;
}

.con_bot {
	width: 720px;
	height: auto;
	margin-left: 111px;
}

.bot_top {
	width: 100%;
	height: 80px;
	margin-bottom: 15px;
}

.copy_img {
	width: 80px;
	height: 80px;
	float: left;
}

.bot_top_right {
	float: left;
	margin-left: 34px;
	color: #404040;
}

.bot_top_right p {
	padding-top: 15px;
	font-size: 16px;
	font-weight: bold;
	margin-bottom: 16px;
}

.codeMsg{
	display: flex;
	justify-content: flex-start;
	align-items: center;
	padding-left: 115px;
	margin-bottom: 34px;
}
.codeMsg input{
	height: 40px;
	width: 485px;
	margin-right: 15px;
	box-sizing: border-box;
	text-indent: 10px;
	border-radius: 3px;
}
.codeMsg span{
	cursor: pointer;
	width: 80px;
	height: 40px;
	background: rgba(24, 144, 255, 1);
	color: #fff;
	border-radius:3px ;
	text-align: center;
	line-height: 38px;
}
.b1{
	border: 2px solid red;
}
.b2{
	border: 2px solid #66b92e;
}
.codeMsg span:hover{
	background: blue;
}
.payment,.bot_center{
	width: 583px;
	height: auto;
	margin: 0 0 10px 120px;
	line-height: 32px;
}

.add {
	vertical-align: middle;
	display: inline-block;
	position: relative;
	cursor: pointer;
	font-size: 14px;
	font-family: PingFangSC-Regular;
	font-weight: 400;
	color: rgba(0, 0, 0, 0.65);
	line-height: 32px;
	width: 106px;
	height: 32px;
	background: rgba(255, 255, 255, 1) url(../../static/img/input.png) no-repeat;
	background-size: 100%;
	margin: 0 37px 0 15px;
}
	
.file {
	position: absolute;
	left: -9999px;
}
.upload {
	margin-right: 35px;
	cursor: pointer;
	text-align: center;
	display: inline-block;
	width: 53px;
	height: 31px;
	background: rgba(0, 118, 255, 1);
	border-radius: 3px;
	color: #fff;
}
	
.note {
	text-indent: 200px;
	color: #CFD4D6;
	margin-bottom: 30px;
}
	

.bot_center{	
	margin: 0 0 30px 120px;
}
.jfpz {
	display: inline-block;
	font-size: 16px;
	font-weight: bold;
	color: #404040;
}
.query{
	display: inline-block;
	top: 45px;
	right: 45px;
	color: #fff;
	width: 124px;
	height: 40px;
	background: #0076ff;
	border-radius: 3px;
	border: none;
	box-sizing: border-box;
	margin: 0 20px 0 10px;
}

.bot_bot {
	width: 583px;
	height: auto;
	margin: 0 0 35px 120px;
	overflow: hidden;
}

.bot_bot p {
	color: #404040;
	font-size: 16px;
	font-weight: bold;
	margin-bottom: 10px;
}
.msg {
	position: relative;
	width: 560px;
	height: 110px;
	background: rgba(255, 245, 204, 1);
	padding: 20px 0 0 23px;
	border-radius: 5px;
	margin-bottom: 50px;
}
.msg p {
	font-size: 14px;
	font-family: PingFangSC-Regular;
	font-weight: 400;
	color: rgba(64, 64, 64, 1);
	line-height: 24px;
}
.msg span {
	position: absolute;
	top: -10px;
	width: 0;
	height: 0;
	border-right: 10px solid transparent;
	border-left: 10px solid transparent;
	border-bottom: 10px solid rgba(255, 245, 204, 1);
}
.to_invoice {
	position: absolute;
	text-align: center;
	line-height: 40px;
	top: 45px;
	right: 45px;
	color: #fff;
	width: 124px;
	height: 40px;
	background: rgba(255, 150, 0, 1);
	border-radius: 3px;
}
.pay_box{
	width:438px;
	height:50px;
	border-radius:3px;
	border:1px solid rgba(211,211,211,1);
	box-sizing: border-box;
	float: left;
	line-height: 50px;
}
.pay_btn{
	float:right;
	width:125px;
	height:48px;
	background: rgba(24, 144, 255, 1);
	border-radius:3px;
	border: none;
	color: #fff;
}
.pay_btn:hover{
	background: blue;		
}
</style>



// WEBPACK FOOTER //
// src/components/Person2.vue